import React, { useEffect, useState } from "react";
import HeaderAdmin from "../../../components/headerAdmin";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import useSnack from "../../../hooks/useSnack";
import useApi from "../../../hooks/useApi";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  LinearProgress,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
  tableCellClasses,
  useMediaQuery,
} from "@mui/material";
import SnackAlert from "../../../components/SnackAlert";
import SwiperImages from "../../../components/SwiperImages";
import { LoadingButton } from "@mui/lab";
import { Add, Check, Close, Edit } from "@mui/icons-material";

function dateToInput(fechaOriginal) {
  if (!!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
    const dateObject = new Date(fechaOriginal);
    const año = dateObject.getUTCFullYear();
    const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
    const día = dateObject.getUTCDate().toString().padStart(2, "0");

    return `${año}-${mes}-${día}`;
  } else return fechaOriginal;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0B2A41",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "normal",
  },
}));




function TableData({ data }) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <>
      <Grid container spacing={2}>
        {(data || []).map((elementTable, index) => {
          return (
            <Grid item xs={12} md={6} key={index}>
              <TableContainer component={Paper} key={index} sx={{ mb: 2 }}>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      {(elementTable?.header || []).map((headerEl, index) => {
                        return (
                          <StyledTableCell
                            key={index}
                            width={index === 0 ? "50%" : "25%"}
                            sx={{ textAlign: index !== 0 ? "right" : "left" }}
                          >
                            {headerEl}
                          </StyledTableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {elementTable.body.map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell align="left">
                          {row.name}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.col1}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.col2}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}

const DesktopVersion = ({
  detailData,
  tableInfo,
  stadisticsData,
  setModalNewBill,
  setModalNewIncome,
  showSnack,
  loadApi,
  modalOpen,
  setModalOpen,
  setModalDelete,
  ActionButtons,
  setDataDelete,
  setModalDeleteBill,
  setModalEditBill,
  setDataEditBill,
  setModalEditIncome,
}) => {

  return (
    <>
      <Stack component="section" mb={4} mt={{ xs: 3, lg: 6 }}>
        <Typography component="h3" variant="h5">
          ¿Qué es {detailData.project.name}?
        </Typography>
        <Typography
          mt={2}
          fontWeight="normal"
          sx={{ wordWrap: 'break-word', maxWidth: '100%' }}
        >
          {detailData.project.information}
        </Typography>

      </Stack>
      <Stack mb={4}>
        <SwiperImages data={detailData.project.gallery} slides={3} />
      </Stack>
      <Stack mb={4}>
        <TableData data={tableInfo} />
      </Stack>
      <Stack mb={8}>
        <Typography component="h3" variant="h6" mb={2}>
          Seguimiento detallado
        </Typography>
        <Stack flexDirection={"column"} gap={4}>
          <Stack
            sx={{
              width: "100%",
            }}
          >
            <Typography
              component="span"
              my={2}
              fontWeight={400}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              Gastos
              <IconButton
                size="small"
                onClick={() => {
                  setModalNewBill(true);
                }}
                sx={{
                  backgroundColor: "primary.300",
                  color: "white",
                  "&:hover": { backgroundColor: "primary.main" },
                }}
              >
                <Add fontSize="small" />
              </IconButton>
            </Typography>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 440, overflowX: "auto" }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell width="40%">Nombre</StyledTableCell>
                      <StyledTableCell width="20%">Valor</StyledTableCell>
                      <StyledTableCell
                        sx={{ whiteSpace: "nowrap" }}
                        width="20%"
                      >
                        Fecha de Creación
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{ whiteSpace: "nowrap" }}
                        width="20%"
                        align="center"
                      >
                        Acciones
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {stadisticsData.bills.length === 0 ? (
                    <Typography
                      py={2}
                      px={2}
                      fontSize="0.874rem"
                      textAlign="left"
                      color="GrayText"
                      fontWeight={400}
                    >
                      Sin gastos por el momento
                    </Typography>
                  ) : (
                    <TableBody>
                      {(stadisticsData.bills || []).map((row) => (
                        <TableRow hover key={row.id}>
                          <TableCell width="40%">{row.name}</TableCell>
                          <TableCell width="20%">
                            {parseInt(row?.value).toLocaleString("es-CO")}
                          </TableCell>
                          <TableCell width="20%">
                            {dateToInput(row?.createdAt)}
                          </TableCell>
                          <TableCell width="20%" align="center">
                            <IconButton
                              title="Editar"
                              onClick={() => {
                                setDataEditBill(row);
                                setModalEditBill(true);
                              }}
                            >
                              <Edit />
                            </IconButton>
                            <IconButton
                              title="Eliminar"
                              onClick={() => {
                                setDataDelete({
                                  text: "¿Quieres eliminar este gasto?",
                                  id: row.id,
                                });
                                setModalDeleteBill(true);
                              }}
                            >
                              <Close />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Paper>
          </Stack>
          <Stack sx={{ width: "100%" }}>
            <Typography
              component="span"
              my={2}
              fontWeight={400}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              Ingresos previstos
              <IconButton
                size="small"
                sx={{
                  backgroundColor: "primary.300",
                  color: "white",
                  "&:hover": { backgroundColor: "primary.main" },
                }}
                onClick={() => setModalNewIncome(true)}
              >
                <Add fontSize="small" />
              </IconButton>
            </Typography>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 440, overflowX: "auto" }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell width="40%">Nombre</StyledTableCell>
                      <StyledTableCell width="20%">Valor</StyledTableCell>
                      <StyledTableCell
                        sx={{ whiteSpace: "nowrap" }}
                        width="20%"
                      >
                        Fecha de Creación
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{ whiteSpace: "nowrap" }}
                        width="20%"
                        align="center"
                      >
                        Acciones
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {stadisticsData.expected_income.length === 0 ? (
                    <Typography
                      py={2}
                      px={1}
                      fontSize="0.874rem"
                      textAlign="left"
                      color="GrayText"
                      fontWeight={400}
                    >
                      Sin Ingresos por el momento
                    </Typography>
                  ) : (
                    <TableBody>
                      {(stadisticsData.expected_income || []).map((row) => (
                        <TableRow hover key={row.id}>
                          <TableCell width="40%">{row.name}</TableCell>
                          <TableCell width="20%">
                            {parseInt(row?.value).toLocaleString("es-CO")}
                          </TableCell>
                          <TableCell width="20%">
                            {dateToInput(row?.createdAt)}
                          </TableCell>
                          <TableCell width="20%" align="center">
                            <IconButton>
                              <Edit
                                title="Editar"
                                onClick={() => {
                                  setDataEditBill(row);
                                  setModalEditIncome(true);
                                }}
                              />
                            </IconButton>
                            <IconButton
                              title="Eliminar"
                              onClick={() => {
                                setDataDelete({
                                  text: "¿Quieres eliminar este ingreso?",
                                  id: row.id,
                                });
                                setModalDelete(true);
                              }}
                            >
                              <Close />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Paper>
          </Stack>
        </Stack>
      </Stack>
      <ActionButtons
        loadApi={loadApi}
        showSnack={showSnack}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
    </>
  );
};

const MobileVersion = ({
  detailData,
  tableInfo,
  stadisticsData,
  setModalNewBill,
  setModalNewIncome,
  setModalOpen,
  modalOpen,
  loadApi,
  showSnack,
  setModalDelete,
  setDataDelete,
  setModalDeleteBill,
  setModalEditBill,
  setDataEditBill,
  ActionButtons,
  setModalEditIncome,
}) => {
  const [selectedButton, setSelectedButton] = useState("information");

  return (
    <>
      <Stack
        sx={{
          backgroundColor: "primary.300",
          borderRadius: 2,
          mt: 4,
          mb: 4,
        }}
      >
        <Grid container>
          <Grid item xs={4}>
            <Button
              onClick={() => setSelectedButton("information")}
              sx={{
                borderRadius: 2,
                p: 2,
                color: "white",
                backgroundColor:
                  selectedButton === "information" ? "primary.lighter" : "none",
              }}
              fullWidth
            >
              Información
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              onClick={() => setSelectedButton("gallery")}
              sx={{
                borderRadius: 2,
                p: 2,
                color: "white",
                backgroundColor:
                  selectedButton === "gallery" ? "primary.lighter" : "none",
              }}
              fullWidth
            >
              Galería
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              onClick={() => setSelectedButton("metrics")}
              sx={{
                borderRadius: 2,
                p: 2,
                color: "white",
                backgroundColor:
                  selectedButton === "metrics" ? "primary.lighter" : "none",
              }}
              fullWidth
            >
              Métricas
            </Button>
          </Grid>
        </Grid>
      </Stack>
      {selectedButton === "information" ? (
        <Stack component="section" mb={3}>
          <Typography component="h3" variant="h5">
            ¿Qué es {detailData.project.name}?
          </Typography>
          <Typography mt={2} mb={4} fontWeight="normal">
            {detailData.project.information}
          </Typography>
          <Stack mb={8}>
            <Typography component="h3" variant="h6" mb={2}>
              Seguimiento detallado
            </Typography>
            <Stack flexDirection={"column"} gap={4}>
              <Stack
                sx={{
                  width: "100%",
                }}
              >
                <Typography
                  component="span"
                  my={2}
                  fontWeight={400}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  Gastos
                  <IconButton
                    size="small"
                    onClick={() => {
                      setModalNewBill(true);
                    }}
                    sx={{
                      backgroundColor: "primary.300",
                      color: "white",
                      "&:hover": { backgroundColor: "primary.main" },
                    }}
                  >
                    <Add fontSize="small" />
                  </IconButton>
                </Typography>
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer sx={{ maxHeight: 440, overflowX: "auto" }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width="40%">Nombre</StyledTableCell>
                          <StyledTableCell width="20%">Valor</StyledTableCell>
                          <StyledTableCell
                            sx={{ whiteSpace: "nowrap" }}
                            width="20%"
                          >
                            Fecha de Creación
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{ whiteSpace: "nowrap" }}
                            width="20%"
                            align="center"
                          >
                            Acciones
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      {stadisticsData.bills.length === 0 ? (
                        <Typography
                          py={2}
                          px={1}
                          fontSize="0.874rem"
                          textAlign="center"
                          color="GrayText"
                          fontWeight={400}
                          whiteSpace="nowrap"
                        >
                          Sin gastos por el momento
                        </Typography>
                      ) : (
                        <TableBody>
                          {(stadisticsData.bills || []).map((row) => (
                            <TableRow hover key={row.id}>
                              <TableCell width="40%">{row.name}</TableCell>
                              <TableCell width="20%">
                                {parseInt(row?.value).toLocaleString("es-CO")}
                              </TableCell>
                              <TableCell width="20%">
                                {dateToInput(row?.createdAt)}
                              </TableCell>
                              <TableCell width="20%" align="center">
                                <IconButton
                                  title="Editar"
                                  onClick={() => {
                                    setDataEditBill({
                                      name: row.name,
                                      value: row.value,
                                      id: row.id,
                                    });
                                    setModalEditBill(true);
                                  }}
                                >
                                  <Edit />
                                </IconButton>
                                <IconButton
                                  title="Eliminar"
                                  onClick={() => {
                                    setDataDelete({
                                      text: "¿Quieres eliminar este gasto?",
                                      id: row.id,
                                    });
                                    setModalDeleteBill(true);
                                  }}
                                >
                                  <Close />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                </Paper>
              </Stack>
              <Stack sx={{ width: "100%" }}>
                <Typography
                  component="span"
                  my={2}
                  fontWeight={400}
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  Ingresos previstos
                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: "primary.300",
                      color: "white",
                      "&:hover": { backgroundColor: "primary.main" },
                    }}
                    onClick={() => setModalNewIncome(true)}
                  >
                    <Add fontSize="small" />
                  </IconButton>
                </Typography>
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer sx={{ maxHeight: 440, overflowX: "auto" }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width="40%">Nombre</StyledTableCell>
                          <StyledTableCell width="20%">Valor</StyledTableCell>
                          <StyledTableCell
                            sx={{ whiteSpace: "nowrap" }}
                            width="20%"
                          >
                            Fecha de Creación
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{ whiteSpace: "nowrap" }}
                            width="20%"
                            align="center"
                          >
                            Acciones
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      {stadisticsData.expected_income.length === 0 ? (
                        <Typography
                          py={2}
                          px={1}
                          fontSize="0.874rem"
                          textAlign="center"
                          color="GrayText"
                          fontWeight={400}
                          whiteSpace="nowrap"
                        >
                          Sin Ingresos por el momento
                        </Typography>
                      ) : (
                        <TableBody>
                          {(stadisticsData.expected_income || []).map((row) => (
                            <TableRow hover key={row.id}>
                              <TableCell width="40%">{row.name}</TableCell>
                              <TableCell width="20%">
                                {parseInt(row?.value).toLocaleString("es-CO")}
                              </TableCell>
                              <TableCell width="20%">
                                {dateToInput(row?.createdAt)}
                              </TableCell>
                              <TableCell width="20%" align="center">
                                <IconButton>
                                  <Edit
                                    title="Editar"
                                    onClick={() => {
                                      setDataEditBill(row);
                                      setModalEditIncome(true);
                                    }}
                                  />
                                </IconButton>
                                <IconButton
                                  title="Eliminar"
                                  onClick={() => {
                                    setDataDelete({
                                      text: "¿Quieres eliminar este ingreso?",
                                      id: row.id,
                                    });
                                    setModalDelete(true);
                                  }}
                                >
                                  <Close />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                </Paper>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      ) : selectedButton === "gallery" ? (
        <Stack mb={3}>
          <SwiperImages data={detailData.project.gallery} slides={1} />
        </Stack>
      ) : (
        <Stack mb={3}>
          <TableData data={tableInfo} />
        </Stack>
      )}
      <ActionButtons
        loadApi={loadApi}
        showSnack={showSnack}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
    </>
  );
};

const RenderedSection = ({
  detailData,
  listData,
  tableInfo,
  setModalOpen,
  modalOpen,
  loadApi,
  showSnack,
  stadisticsData,
  setModalNewBill,
  setModalNewIncome,
  ActionButtons,
  setModalDelete,
  setDataDelete,
  setModalDeleteBill,
  setModalEditBill,
  setDataEditBill,
  setModalEditIncome,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack>
      <Box sx={{ width: "100%", height: { xs: 320, md: 400 } }}>
        <img
          src={detailData.project.photo_profile[0].url}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>
      <Stack px={{ xs: 2, md: 4 }}>
        <Stack component="section" pt={5}>
          <Typography component="h2" variant="h5" mb={2}>
            {detailData.project.name}
          </Typography>
          <Typography
            component="span"
            sx={{
              backgroundColor: "secondary.typePropertySpan",
              width: "fit-content",
              px: 2,
              py: 0.5,
              borderRadius: 3,
              mb: 5,
              fontWeight: "normal",
            }}
          >
            {detailData.project.name_business}
          </Typography>
          {/* <ListingDetails data={listData} /> */}
          <Stack>
            <Grid container spacing={2}>
              {(listData || []).map((detailData, index) => {
                return (
                  <Grid item xs={6} md={4} key={index}>
                    <Box
                      sx={{
                        boxShadow: "2px 3px 5px #7d7d7d24",
                        borderRadius: 2,
                        p: 2,
                      }}
                    >
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={2}
                        mb={1}
                      >
                        <detailData.icon
                          sx={{
                            color: "gray",
                            backgroundColor: "#F3F4F6",
                            p: 1,
                            borderRadius: "50%",
                          }}
                        />
                        <Typography
                          component="h3"
                          variant="subtitle1"
                          fontWeight={400}
                          color="#303030ed"
                        >
                          {detailData.title}
                        </Typography>
                      </Box>
                      <Typography component="span" fontFamily={"sans-serif"}>
                        {detailData.value}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Stack>
        </Stack>
        <Stack mt={6}>
          <Typography component="h3" variant="h5" mb={2}>
            Progreso del proyecto
          </Typography>
          <Stack flexDirection="row" justifyContent="space-between" mb={1}>
            <Typography
              fontWeight="normal"
              display={"flex"}
              alignItems={"center"}
              gap={1}
              fontSize={{ xs: "small", md: "large" }}
            >
              Invertidos:{" "}
              <Typography fontWeight={700}>
                {parseInt(detailData.project.invested).toLocaleString("es-CO")}€
              </Typography>
            </Typography>
            <Typography
              fontWeight="normal"
              display={"flex"}
              alignItems={"center"}
              gap={1}
              fontSize={{ xs: "small", md: "large" }}
            >
              Objetivo:{" "}
              <Typography fontWeight={700}>
                {parseInt(detailData.project.objective).toLocaleString("es-CO")}€
              </Typography>
            </Typography>
          </Stack>
          <LinearProgress
            variant="determinate"
            value={
              parseInt(detailData.project.completed) > 100
                ? 100
                : parseInt(detailData.project.completed)
            }
            sx={{ height: "10px", fill: "primary.300", borderRadius: 1 }}
          />
        </Stack>
        {isSmallScreen ? (
          <MobileVersion
            setModalEditBill={setModalEditBill}
            setModalDeleteBill={setModalDeleteBill}
            setDataDelete={setDataDelete}
            setModalDelete={setModalDelete}
            detailData={detailData}
            ActionButtons={ActionButtons}
            tableInfo={tableInfo}
            setModalOpen={setModalOpen}
            modalOpen={modalOpen}
            loadApi={loadApi}
            showSnack={showSnack}
            stadisticsData={stadisticsData}
            setModalNewBill={setModalNewBill}
            setModalNewIncome={setModalNewIncome}
            setDataEditBill={setDataEditBill}
            setModalEditIncome={setModalEditIncome}
          />
        ) : (
          <DesktopVersion
            setModalEditBill={setModalEditBill}
            setModalDeleteBill={setModalDeleteBill}
            setDataDelete={setDataDelete}
            ActionButtons={ActionButtons}
            setModalOpen={setModalOpen}
            modalOpen={modalOpen}
            loadApi={loadApi}
            showSnack={showSnack}
            setModalDelete={setModalDelete}
            detailData={detailData}
            tableInfo={tableInfo}
            stadisticsData={stadisticsData}
            setModalNewBill={setModalNewBill}
            setModalNewIncome={setModalNewIncome}
            setDataEditBill={setDataEditBill}
            setModalEditIncome={setModalEditIncome}
          />
        )}
      </Stack>
    </Stack>
  );
};

function PreviewProject() {
  const [detailData, setDetailData] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [listData, setListData] = useState([
    {
      title: "Inversión Minima",
      icon: LocalActivityIcon,
      value: "",
    },
    {
      title: "Invertidos",
      icon: LocalAtmIcon,
      value: "",
    },
    {
      title: "Rentabilidad",
      icon: AutoGraphIcon,
      value: "",
    },
    {
      title: "Inversores",
      icon: PersonOutlineOutlinedIcon,
      value: "",
    },
    {
      title: "Días Restantes",
      icon: WatchLaterOutlinedIcon,
      value: "",
    },
    {
      title: "Objetivo",
      icon: StarOutlinedIcon,
      value: "",
    },
  ]);
  const navigate = useNavigate();
  const [loadingButtonDelete, setLoadingButtonDelete] = useState(false);
  const [stadisticsData, setStadisticsData] = useState(false);
  const [tableInfo, setTableInfo] = useState(false);
  const params = useParams();
  const [modalNewBill, setModalNewBill] = useState(false);
  const [modalNewIncome, setModalNewIncome] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalDeleteBill, setModalDeleteBill] = useState(false);
  const [modalEditBill, setModalEditBill] = useState(false);
  const [modalEditIncome, setModalEditIncome] = useState(false);
  const [dataDelete, setDataDelete] = useState({ text: "", id: "" });
  const [dataNewBill, setDataNewBill] = useState({
    name: "",
    value: "",
  });
  const [dataEditBill, setDataEditBill] = useState(undefined);
  const [isLoadingModals, setIsLoadingModals] = useState(false);

  // UTILS
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");

    return rawValue;
  };

  const formatNumberWithDots = (number) => {
    if (number === undefined) {
      return "";
    }
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const ModalReject = ({
    modalOpen,
    setModalOpen,
    loadingButtonDelete,
    handlerDelete,
  }) => {
    return (
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h2" variant="h6" mb={2}>
            Confirmación
          </Typography>
          <Typography mb={2} fontWeight="normal">
            ¿Estás seguro que quieres rechazarlo?
          </Typography>
          <Stack flexDirection="row" justifyContent="flex-end">
            <Button
              sx={{ mr: 1.5 }}
              onClick={() => setModalOpen(false)}
              disabled={loadingButtonDelete ? true : false}
            >
              CANCELAR
            </Button>
            <LoadingButton
              loading={loadingButtonDelete}
              variant="contained"
              sx={{ color: "white" }}
              onClick={handlerDelete}
            >
              CONFIRMAR
            </LoadingButton>
          </Stack>
        </Box>
      </Modal>
    );
  };

  function ActionButtons({
    loadApi,
    showSnack,
    modalOpen,
    setModalOpen,
    status,
  }) {
    const [isLoading, setIsLoading] = useState(false);

    const params = useParams();


    const acceptProject = async () => {
      setIsLoading(true);
      loadApi(`superadmin/projects/${params.id}`, true, "put", {
        verified: "approved",
      })
        .then((response) => {
          showSnack(response.data.message, "success");
          setTimeout(() => {
            navigate("/dashboard/projects/pending");
          }, 2000);
        })
        .catch((e) => showSnack(e.message))
        .finally(() => setIsLoading(false));
    };

    return (
      <Stack
        component="section"
        flexDirection="row"
        gap={2}
        sx={{
          width: { xs: "85%", md: "100%" },
          marginInline: "auto",
          justifyContent: "right",
        }}
      >
        <Button
          variant="outlined"
          onClick={() => setModalOpen(true)}
          disabled={status === "rejected"}
          sx={{
            alignItems: "center",
            gap: 1,
            width: {
              xs: "100%",
              md: "fit-content",
            },
            borderRadius: 2,
            px: { xs: 0, md: 5 },
          }}
        >
          <CloseIcon />
          {status === "rejected" ? "Está rechazado" : "Rechazar"}
        </Button>
      </Stack>
    );
  }


  const GetDetails = async () => {
    setOpenBackDrop(true);
    loadApi(`superadmin/projects/${params.id}`, true, "get")
      .then((response) => {
        setStadisticsData({
          bills: response.data.project.BillsProjects,
          expected_income: response.data.project.ExpectedIncomes,
        });
        const dataMapping = {
          "Inversión Minima":
            parseInt(response.data.project.min_investment).toLocaleString("es-ES") +
            "Є",
          Invertidos: parseInt(response.data.project.invested).toLocaleString("es-ES"),
          Rentabilidad:
            parseInt(response.data.project.esti_profitability).toLocaleString("es-ES") +
            "%",
          Completado: response.data.project.completed + "%",
          Inversores: response.data.project.cant_investors,
          "Días Restantes": response.data.diffDays,
          Objetivo:
            parseInt(response.data.project.objective).toLocaleString("es-CO") + "Є",
        };
        const updatedListData = listData.map((item) => ({
          ...item,
          // value: dataMapping[item.title] || item.value,
          value: dataMapping[item.title]
        }));

        const updatedTableInfo = [
          {
            header: ["Inversión", "MIN", "MAX"],
            body: [
              {
                name: "Capital Ofrecido",
                col1: parseInt(
                  response.data.project.DetailProject.min_offered_capital
                ).toLocaleString("es-CO"),
                col2: parseInt(
                  response.data.project.DetailProject.max_offered_capital
                ).toLocaleString("es-CO"),
              },
              {
                name: "Participaciones a emitir",
                col1: response.data.project.DetailProject.min_stake,
                col2: response.data.project.DetailProject.max_stake,
              },
              {
                name: "Valor por participación",
                col1: parseInt(response.data.project.min_investment).toLocaleString(
                  "es-CO"
                ),
                col2: parseInt(response.data.project.objective).toLocaleString("es-CO"),
              },
            ],
          },
          {
            header: ["Rentabilidad Estimada", "MIN", "MAX"],
            body: [
              {
                name: "Retorno de inversión",
                col1: parseInt(
                  response.data.project.DetailProject.min_return_investment
                ).toLocaleString("es-CO"),
                col2: parseInt(
                  response.data.project.DetailProject.max_return_investment
                ).toLocaleString("es-CO"),
              },
              {
                name: "Rentabilidad recursos propios",
                col1: parseInt(response.data.project.esti_profitability).toLocaleString(
                  "es-CO"
                ),
                col2: parseInt(response.data.project.objective).toLocaleString("es-CO"),
              },
            ],
          },
          {
            header: ["Destino Inversión", "MIN", "MAX"],
            body: [
              {
                name: "Marketing",
                col1: parseInt(response.data.project.DetailProject.min_marketing).toLocaleString(
                  "es-CO"
                ),
                col2: parseInt(response.data.project.DetailProject.max_marketing).toLocaleString(
                  "es-CO"
                ),
              },
              {
                name: "Construcción",
                col1: parseInt(response.data.project.DetailProject.min_construction).toLocaleString(
                  "es-CO"
                ),
                col2: parseInt(response.data.project.DetailProject.max_construction).toLocaleString(
                  "es-CO"
                ),
              },
            ],
          },
          {
            header: ["Garantías", "", "Valor"],
            body: [
              {
                name: "Inmobiliaria",
                col1: "",
                col2: response.data.project.DetailProject.warranty_economica ? parseInt(response.data.project.DetailProject.warranty_economica).toLocaleString(
                  "es-CO"
                ) : "No disponible",
              },
              {
                name: "Económica",
                col1: "",
                col2: response.data.project.DetailProject.warranty_inmobiliaria ? parseInt(response.data.project.DetailProject.warranty_inmobiliaria).toLocaleString(
                  "es-CO"
                ) : "No disponible",
              },
            ],
          },
        ];

        setTableInfo(updatedTableInfo);

        setListData(updatedListData);
        setDetailData(response.data);
      })
      .catch((e) => {
        console.log(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  };

  const handleNewBill = (type = "bill") => {
    if (dataNewBill.name === "" || dataNewBill.value === "") {
      showSnack("Debe llenar todos los campos");
      return;
    }

    if (dataNewBill.value.startsWith("0")) {
      showSnack("El valor no puede ser cero");
      return;
    }

    if (dataNewBill.value.startsWith("-")) {
      showSnack("El valor no puede ser negativo");
      return;
    }

    setIsLoadingModals(true);
    if (type === "bill") {
      loadApi("superadmin/projects/bills/" + params.id, true, "post", { ...dataNewBill })
        .then((response) => {
          let tempData = stadisticsData;
          if (type === "bill") {
            tempData = {
              ...tempData,
              bills: [...tempData.bills, response.data.newBill],
            };
          } else {
            tempData = {
              ...tempData,
              expected_income: [
                ...tempData.expected_income,
                response.data.newExpectedIncome,
              ],
            };
          }
          setDataNewBill({ name: "", value: "" });
          setStadisticsData(tempData);
          showSnack(
            type === "bill"
              ? response.data.message
              : "Ingreso previsto añadido",
            "success"
          );
          setModalNewBill(false);
          setModalNewIncome(false);
        })
        .catch((e) => {
          showSnack(e.message);
        })
        .finally(() => {
          setIsLoadingModals(false);
        });
    } else {
      loadApi("superadmin/projects/expected/" + params.id, true, "post", {
        ...dataNewBill,
      })
        .then((response) => {
          let tempData = stadisticsData;
          if (type === "bill") {
            tempData = {
              ...tempData,
              bills: [...tempData.bills, response.data.newBill],
            };
          } else {
            tempData = {
              ...tempData,
              expected_income: [
                ...tempData.expected_income,
                response.data.newExpectedIncome,
              ],
            };
          }

          setDataNewBill({ name: "", value: "" });
          setStadisticsData(tempData);
          showSnack(
            type === "bill" ? "Gasto Añdido" : "Ingreso previsto añadido",
            "success"
          );
          setModalNewBill(false);
          setModalNewIncome(false);
        })
        .catch((e) => {
          showSnack(e.message);
        })
        .finally(() => {
          setIsLoadingModals(false);
        });
    }
  };
  const handleDeleteBill = (type = "bill") => {
    setIsLoadingModals(true);
    if (type === "bill") {
      loadApi("superadmin/projects/bills/" + dataDelete.id, true, "delete")
        .then((response) => {
          let tempData = stadisticsData.bills.filter(
            (x) => x.id !== dataDelete.id
          );
          setStadisticsData({ ...stadisticsData, bills: tempData });
          setDataDelete({ text: "", id: "" });
          showSnack(response.data.message, "success");
        })
        .catch((e) => {
          showSnack(e.messagge);
        })
        .finally(() => {
          setIsLoadingModals(false);
          setModalDeleteBill(false);
        });
    } else {
      loadApi(
        "superadmin/projects/expected/" + dataDelete.id,
        true,
        "delete"
      )
        .then((response) => {
          let tempData = stadisticsData.expected_income.filter(
            (x) => x.id !== dataDelete.id
          );
          setStadisticsData({ ...stadisticsData, expected_income: tempData });
          setDataDelete({ text: "", id: "" });
          showSnack(response.data.message, "success");
        })
        .catch((e) => {
          showSnack(e.messagge);
        })
        .finally(() => {
          setIsLoadingModals(false);
          setModalDelete(false);
        });
    }
  };
  const handleEditBill = (type = "bill") => {
    setIsLoadingModals(true);
    const myDate = new Date();
    let year = myDate.getFullYear();
    let month = (myDate.getMonth() + 1).toString().padStart(2, "0");
    let day = myDate.getDate().toString().padStart(2, "0");
    let resultDate = `${year}-${month}-${day}`;
    if (type === "bill") {
      loadApi("superadmin/projects/bills/" + dataEditBill.id, true, "put", {
        name: dataEditBill.name,
        value: dataEditBill.value,
      })
        .then((response) => {
          let tempData = stadisticsData;
          tempData = {
            ...tempData,
            bills: tempData.bills.map((bill) =>
              bill.id === dataEditBill.id ? dataEditBill : bill
            ),
          };
          setStadisticsData(tempData);
          setDataEditBill({ name: "", value: "", id: "" });
          showSnack(response.data.message, "success");
        })
        .catch((e) => {
          showSnack(e.messagge);
        })
        .finally(() => {
          setIsLoadingModals(false);
          setModalEditBill(false);
        });
    } else {
      loadApi(
        "superadmin/projects/expected/" + dataEditBill.id,
        true,
        "put",
        {
          name: dataEditBill.name,
          value: dataEditBill.value,
        }
      )
        .then((response) => {
          let tempData = stadisticsData;
          tempData = {
            ...tempData,
            expected_income: tempData.expected_income.map((bill) =>
              bill.id === dataEditBill.id ? dataEditBill : bill
            ),
          };
          setStadisticsData(tempData);

          setDataEditBill({ name: "", value: "", id: "" });
          showSnack(response.data.message, "success");
        })
        .catch((e) => {
          showSnack(e.messagge);
        })
        .finally(() => {
          setIsLoadingModals(false);
          setModalEditIncome(false);
        });
    }
  };
  const handlerDelete = () => {
    setLoadingButtonDelete(true);
    loadApi("superadmin/projects/" + params.id, true, "put", {
      verified: "rejected",
    })
      .then((response) => {
        showSnack("Proyecto rechazado", "success");
        setModalOpen(false);
        setTimeout(() => {
          navigate("/dashboard/projects/pending");
        }, 2000);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setLoadingButtonDelete(false));
  };



  useEffect(() => {
    GetDetails();
  }, []);
  return (
    <>
      <HeaderAdmin />
      <Stack
        component="main"
        sx={{
          minHeight: "90vh",
          width: { xs: "100vw", sm: "90vw", md: "85vw", lg: "65vw" },
          marginInline: "auto",
          pb: 4,
          backgroundColor: "white",
        }}
      >
        {detailData && (
          <>
            {/* IF THE ARRAY IS EMPTY THIS WILL BE SHOW IT */}
            {detailData.error && (
              <Stack sx={{ mt: 10 }}>
                <Typography textAlign="center" variant="h5">
                  Lo sentimos, datos no encontrados
                </Typography>
              </Stack>
            )}
            {/* IN CASE THAT THE ERROR KEY DOESNT EXIST, THE DATA IS RENDERED */}
            {!detailData.error && stadisticsData ? (
              <RenderedSection
                setModalDelete={setModalDelete}
                stadisticsData={stadisticsData}
                detailData={detailData}
                setModalOpen={setModalOpen}
                modalOpen={modalOpen}
                listData={listData}
                tableInfo={tableInfo}
                loadApi={loadApi}
                showSnack={showSnack}
                ActionButtons={ActionButtons}
                setModalNewBill={setModalNewBill}
                setModalNewIncome={setModalNewIncome}
                setDataDelete={setDataDelete}
                setModalDeleteBill={setModalDeleteBill}
                setModalEditBill={setModalEditBill}
                setDataEditBill={setDataEditBill}
                setModalEditIncome={setModalEditIncome}
              />
            ) : (
              ""
            )}
          </>
        )}
      </Stack>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalReject
        modalOpen={modalOpen}
        handlerDelete={handlerDelete}
        setModalOpen={setModalOpen}
        loadingButtonDelete={loadingButtonDelete}
      />
      <Modal open={modalDelete}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={1}>
            Eliminar
          </Typography>
          <Stack gap={2}>
            <Typography component="p" fontWeight={400}>
              {dataDelete.text}
            </Typography>
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={isLoadingModals ? true : false}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => setModalDelete(false)}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={isLoadingModals}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                handleDeleteBill("income");
              }}
            >
              Eliminar
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
      <Modal open={modalDeleteBill}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={1}>
            Eliminar
          </Typography>
          <Stack gap={2}>
            <Typography component="p" fontWeight={400}>
              {dataDelete.text}
            </Typography>
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={isLoadingModals ? true : false}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => setModalDeleteBill(false)}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={isLoadingModals}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                handleDeleteBill();
              }}
            >
              Eliminar
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
      <Modal open={modalNewBill}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={1}>
            Añadir nuevo gasto
          </Typography>
          <Stack gap={2}>
            <TextField
              label="Nombre"
              value={dataNewBill.name}
              onChange={({ target }) => {
                setDataNewBill({ ...dataNewBill, name: target.value });
              }}
            />
            <TextField
              label="Valor"
              value={formatNumberWithDots(dataNewBill.value)}
              onChange={({ target }) => {
                let result = handleChange(target.value);
                if (/^\d*$/.test(result)) {
                  setDataNewBill({ ...dataNewBill, value: result });
                }
              }}
            />
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={isLoadingModals ? true : false}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => setModalNewBill(false)}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={isLoadingModals}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                handleNewBill("bill");
              }}
            >
              Crear
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
      <Modal open={modalNewIncome}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={1}>
            Añadir Ingreso Previsto
          </Typography>
          <Stack gap={2}>
            <TextField
              label="Nombre"
              value={dataNewBill.name}
              onChange={({ target }) => {
                setDataNewBill({ ...dataNewBill, name: target.value });
              }}
            />
            <TextField
              label="Valor"
              value={formatNumberWithDots(dataNewBill.value)}
              onChange={({ target }) => {
                let result = handleChange(target.value);
                if (/^\d*$/.test(result)) {
                  setDataNewBill({ ...dataNewBill, value: result });
                }
              }}
            />
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={isLoadingModals ? true : false}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => setModalNewIncome(false)}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={isLoadingModals}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                handleNewBill("income");
              }}
            >
              Crear
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
      <Modal open={modalEditBill}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={2}>
            Editar gasto
          </Typography>
          <Stack gap={2}>
            <TextField
              label="Nombre"
              value={dataEditBill?.name || ""}
              onChange={({ target }) => {
                setDataEditBill({ ...dataEditBill, name: target.value });
              }}
            />
            <TextField
              label="Valor"
              value={formatNumberWithDots(dataEditBill?.value || "")}
              onChange={({ target }) => {
                let result = handleChange(target.value);
                if (/^\d*$/.test(result)) {
                  setDataEditBill({ ...dataEditBill, value: result });
                }
              }}
            />
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={isLoadingModals ? true : false}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => setModalEditBill(false)}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={isLoadingModals}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                handleEditBill();
              }}
            >
              Actualizar
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
      <Modal open={modalEditIncome}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={2}>
            Editar Ingresos
          </Typography>
          <Stack gap={2}>
            <TextField
              label="Nombre"
              value={dataEditBill?.name || ""}
              onChange={({ target }) => {
                setDataEditBill({ ...dataEditBill, name: target.value });
              }}
            />
            <TextField
              label="Valor"
              value={formatNumberWithDots(dataEditBill?.value || "")}
              onChange={({ target }) => {
                let result = handleChange(target.value);
                if (/^\d*$/.test(result)) {
                  setDataEditBill({ ...dataEditBill, value: result });
                }
              }}
            />
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={isLoadingModals ? true : false}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => setModalEditIncome(false)}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={isLoadingModals}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                handleEditBill("income");
              }}
            >
              Actualizar
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default PreviewProject;
